import React, { useEffect, useState } from 'react';
import { Building2, ExternalLink } from 'lucide-react';
import api from '../utils/api';

const ClientsSection = ({ compact = false }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/clients')
      .then(({ data }) => setClients(Array.isArray(data) ? data : []))
      .catch(() => setClients([]))
      .finally(() => setLoading(false));
  }, []);

  const sorted = [...clients].sort((a, b) => {
    if (Boolean(a.featured) !== Boolean(b.featured)) return a.featured ? -1 : 1;
    return Number(a.order || 0) - Number(b.order || 0);
  });

  if (!loading && sorted.length === 0) return null;

  return (
    <section className="section-padding bg-orvix-navy/30">
      <div className="container-custom mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-orvix-green text-sm font-medium mb-3">شركاء النجاح</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            شركات <span className="gradient-text">عملنا معها</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            نفخر بشركاء النجاح من الشركات والمؤسسات التي تشرفنا بالعمل معها.
          </p>
        </div>

        {loading ? (
          <div className="text-center text-gray-500 py-10">جارٍ تحميل العملاء...</div>
        ) : (
          <div className={`grid gap-5 ${compact ? 'grid-cols-2 md:grid-cols-4 lg:grid-cols-6' : 'sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'}`}>
            {sorted.map(client => {
              const content = (
                <div className="glass h-full p-5 flex flex-col items-center text-center hover:bg-white/10 transition-all group">
                  <div className="w-24 h-24 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center overflow-hidden mb-4">
                    {client.logo ? (
                      <img src={client.logo} alt={client.name} className="w-full h-full object-contain p-3 group-hover:scale-105 transition-transform" />
                    ) : (
                      <Building2 size={34} className="text-orvix-green" />
                    )}
                  </div>
                  <h3 className="text-white font-bold">{client.name}</h3>
                  {client.nameEn && <p dir="ltr" className="text-xs text-gray-500 mt-1">{client.nameEn}</p>}
                  {!compact && client.description && <p className="text-gray-400 text-sm mt-3 leading-6">{client.description}</p>}
                  {!compact && client.website && (
                    <span className="mt-4 inline-flex items-center gap-1 text-orvix-primary text-xs">
                      <ExternalLink size={13} /> زيارة الموقع
                    </span>
                  )}
                </div>
              );

              return client.website ? (
                <a key={client._id} href={client.website} target="_blank" rel="noreferrer" className="block">
                  {content}
                </a>
              ) : (
                <div key={client._id}>{content}</div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default ClientsSection;
